








import { Component, Prop, Vue, Emit } from 'vue-property-decorator';
import * as Common from '@/tenant/common';
import * as Components from '@/tenant/components';

@Component
export default class MatterParamDialog extends Vue {    
　@Prop({ default: null }) public template: Common.ReportTemplate; //呼び出し元がテンプレートを指定
   public params: Common.MatterCustomReportQuery = new Common.MatterCustomReportQuery(); //ReportQueryの派生クラス

　public onReportGenerate(){
    this.params.templateId = this.template.id;
    this.$api.download(this.params);
  }
  public onHidden(){
      this.$emit('hidden');
  }
}
